// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"123789db","293":"c0d6d8c7","413":"91a91d7a","621":"877e56a4","734":"ff342be6","743":"417decd5","757":"ba956fbd"}[chunkId] + ".chunk.js";
};